<div
	class="dispatch-undo-toast"
	*ngIf="toast$ | async as toast"
	[@slideUpOnEnter]
	role="status"
	[class.dispatch-undo-toast--dragging]="dragging"
	[class.dispatch-undo-toast--settling]="settling"
	[style.transform]="dragActive ? 'translateY(' + dragY + 'px)' : null"
	[style.opacity]="dragActive ? dragOpacity : null"
	(pointerdown)="onPointerDown($event)"
	(pointermove)="onPointerMove($event)"
	(pointerup)="onPointerUp()"
	(pointercancel)="onPointerUp()"
	(transitionend)="onSettleEnd()"
>
	<p class="dispatch-undo-toast__message">
		<ng-container *ngIf="toast.unitName; else locationDispatching">
			{{
				"DISPATCH_UNDO__DISPATCHING_UNIT"
					| transloco: { unitName: toast.unitName, count: toast.riders }
			}}
		</ng-container>
		<ng-template #locationDispatching>
			{{ "DISPATCH_UNDO__DISPATCHING" | transloco: { count: toast.riders } }}
		</ng-template>
	</p>

	<button type="button" class="dispatch-undo-toast__action" (click)="cancel()">
		{{ "DISPATCH_UNDO__CANCEL" | transloco }}
	</button>
</div>
